// The org's extensions, keyed by the username Asterisk uses on the wire.
//
// Every call surface needs it — Live Calls, Recent Calls, and the subscriber page's copy of
// both — to turn `43038236611` into `+1 (303) 823-6611`. One query key, so the tables share
// a single read and cannot disagree about which line an extension belongs to.
//
// Long stale time on purpose: extensions do not move while an operator watches a call, and
// this must not re-fetch on every AMI event repaint.

import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export default function useExtensionLines() {
  const q = useQuery({
    queryKey: ['extension-lines'],
    queryFn: () => api.get('/extension-lines'),
    staleTime: 5 * 60_000,
    // A call table renders fine without it — the raw extension shows instead of the number —
    // so a failure here must not take the table down with it.
    retry: 1,
  });
  return q.data?.extensions || null;
}
